import ProtectedHeaderLayout from "./Componets/ProtectedHeaderLayout";
import Dashboard from "./Pages/Dashboard";
import History, { INCOME_REPORTS } from "./Pages/History";
import LeaderBoard from "./Pages/LeaderBoard";
import Offers from "./Pages/Offers";
import Referral from "./Pages/Referral";
import MyTeam from "./Pages/MyTeam";
import TeamTree from "./Pages/TeamTree";
import Support from "./Pages/Support";
import Wallet from "./Pages/Wallet";
import React from "react";
import MyProfile from "./Pages/MyProfile";
import FundRequest from "./Pages/FundRequest";
import FundRequestReport from "./Pages/FundRequestReport";
import FundReceivedReport, { ReferralCoinsReport } from "./Pages/FundReceivedReport";
import AccountSecurity from "./Pages/AccountSecurity";
import WithdrawRequest from "./Pages/WithdrawRequest";
import WithdrawReport from "./Pages/WithdrawReport";
import { Navigate, useLocation } from "react-router-dom";
import LevelIncome from "./Pages/LevelIncome";
import { appRoute } from "../../utils/auth";

/** Old URLs `/user/:mongoId/...` → `/...` */
function LegacyUserMongoRedirect() {
  const { pathname } = useLocation();
  const m = pathname.match(/^\/user\/[^/]+\/?(.*)$/);
  const raw =
    m?.[1] != null && String(m[1]).trim() !== "" ? m[1] : "dashboard";
  const tail = String(raw).replace(/^\/+/, "").replace(/\/$/, "") || "dashboard";
  return <Navigate to={appRoute(tail)} replace />;
}

const Routes = [
  { path: "/user/:id", element: <Navigate to="/dashboard" replace /> },
  { path: "/user/:id/*", element: <LegacyUserMongoRedirect /> },
  {
    element: <ProtectedHeaderLayout />,
    children: [
      { path: "/dashboard", element: <Dashboard /> },
      { path: "/profile", element: <MyProfile /> },
      { path: "/account/transaction-security", element: <AccountSecurity /> },
      { path: "/account/login-security", element: <AccountSecurity /> },
      { path: "/chat", element: <Navigate to="/dashboard" replace /> },
      { path: "/live", element: <Navigate to="/dashboard" replace /> },
      { path: "/live/:sessionId", element: <Navigate to="/dashboard" replace /> },
      { path: "/referral", element: <Referral /> },
      { path: "/team", element: <MyTeam /> },
      { path: "/tree", element: <TeamTree /> },
      { path: "/offers", element: <Offers /> },
      { path: "/wallet", element: <Wallet /> },
      { path: "/plans", element: <Navigate to="/fund/request" replace /> },
      { path: "/fund/request", element: <FundRequest /> },
      { path: "/fund/report", element: <FundRequestReport /> },
      { path: "/fund/received", element: <FundReceivedReport /> },
      { path: "/fund/referral-coins", element: <ReferralCoinsReport /> },
      { path: "/withdraw/request", element: <WithdrawRequest /> },
      { path: "/withdraw/report", element: <WithdrawReport /> },
      { path: "/level", element: <LevelIncome /> },
      { path: "/pool/level", element: <Navigate to="/dashboard" replace /> },
      { path: "/support", element: <Support /> },
      { path: "/leaderboard", element: <LeaderBoard /> },
      ...INCOME_REPORTS.map((report) => ({
        path: `/${report.to}`,
        element: <History incomeType={report.type} title={report.label} />,
      })),
      { path: "/history", element: <Navigate to="/reports/salary" replace /> },
      { path: "/reports/self", element: <Navigate to="/reports/salary" replace /> },
      { path: "/reports/pool", element: <Navigate to="/dashboard" replace /> },
      { path: "/reports/rank", element: <Navigate to="/dashboard" replace /> },
      { path: "/reports/vip", element: <Navigate to="/dashboard" replace /> },
    ],
    
  },
];

export default Routes;
